window.uniqueId = function (data = []) {
  const id = Date.now() + Math.random().toString(32).slice(-8)
  return (data.some(o => o.id === id)) ? window.uniqueId(data) : id
}

window.waitForCond = async function (cond, timeoutms, interval = 50) {
  return new Promise((resolve) => {
    const check = () => {
      if (cond()) {
        resolve(true)
      } else if ((timeoutms -= interval) < 0) {
        resolve(false)
      } else {
        setTimeout(check, interval)
      }
    }
    check()
  })
}

window.waitForIt = (cond, cb) => {
  let timeoutms = 5000
  const check = () => {
    if (cond()) {
      cb()
    } else if ((timeoutms -= 50) < 0) {
      // do-nothing
    } else {
      setTimeout(check, 50)
    }
  }
  check()
}

window.capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

window.hasAdblock = async () => {
  var hasAdblock = false
  var testAd = document.createElement('div')
  testAd.innerHTML = '&nbsp;'
  testAd.className = 'ads ad adsbox doubleclick ad-placement carbon-ads'
  document.body.appendChild(testAd)
  await new Promise(resolve => {
    setTimeout(() => {
      testAd.offsetHeight === 0 && (hasAdblock = true)
      testAd.remove()
      resolve()
    }, 100)
  })
  return hasAdblock
}

window.oSome = (object, field, value) => {
  let result = false
  for (const key of Object.keys(object)) {
    if (object[key][field] === value) {
      result = true
    }
  }
  return result
}

window.oFind = (object, field, value) => {
  let result
  for (const key of Object.keys(object)) {
    if (object[key][field] === value) {
      result = object[key]
      break
    }
  }
  return result
}

window.oFindIndex = (object, field, value) => {
  let result
  for (const key of Object.keys(object)) {
    if (object[key][field] === value) {
      result = key
      break
    }
  }
  return result
}

window.wait = (time) => {
  return new Promise(resolve => setTimeout(resolve, time))
}

window.deepEqual = (a, b) => {
  if (a === b) return true

  if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) {
    return false
  }

  const keysA = Object.keys(a)
  const keysB = Object.keys(b)

  if (keysA.length !== keysB.length) return false

  for (const key of keysA) {
    if (!keysB.includes(key) || !window.deepEqual(a[key], b[key])) return false
  }

  return true
}

window.deepDiff = (a, b, path = '') => {
  const differences = {}

  if (a === b) return false

  if (a == null || b == null) {
    return { [path || 'root']: { from: a, to: b } }
  }

  if (typeof a !== typeof b) {
    return { [path || 'root']: { from: a, to: b } }
  }

  if (typeof a !== 'object') {
    return { [path || 'root']: { from: a, to: b } }
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    const maxLength = Math.max(a.length, b.length)
    const arrayDiffs = {}
    let hasArrayDiffs = false

    for (let i = 0; i < maxLength; i++) {
      const currentPath = path ? `${path}[${i}]` : `[${i}]`
      const diff = window.deepDiff(a[i], b[i], currentPath)

      if (diff) {
        Object.assign(arrayDiffs, diff)
        hasArrayDiffs = true
      }
    }

    return hasArrayDiffs ? arrayDiffs : false
  }

  if (Array.isArray(a) !== Array.isArray(b)) {
    return { [path || 'root']: { from: a, to: b } }
  }

  const allKeys = new Set([...Object.keys(a), ...Object.keys(b)])
  let hasDiffs = false

  for (const key of allKeys) {
    const currentPath = path ? `${path}.${key}` : key
    const diff = window.deepDiff(a[key], b[key], currentPath)

    if (diff) {
      Object.assign(differences, diff)
      hasDiffs = true
    }
  }

  return hasDiffs ? differences : false
}

window.isMobile = () => {
  return window.innerWidth < 1280
}

window.isMobile640 = () => {
  return window.innerWidth < 640
}
